import React from 'react';

import { Rate, Space, Typography } from '@sravni/react-design-system';

import styles from './rating-with-reviews.module.scss';

export const RatingWithReviews = ({ ratingValue }: { ratingValue: number }) => (
  <Space direction="horizontal" align="center">
    {ratingValue && (
      <>
        <Rate count={1} value={1} disabled className={styles.starIcon} size={16} />
        <Typography.Text size={12} className="h-color-D100">
          {String(ratingValue.toFixed(1)).replace('.', ',')}
        </Typography.Text>
      </>
    )}
  </Space>
);
